// Shared cache for dashboard lastTenWinners data
// Uses localStorage for persistence across page refreshes

const CACHE_KEY_PREFIX = "dashboard_lastTenWinners_";

export const dashboardCache = {
  // Get cached data for a specific dashboard
  get(dashboardType) {
    try {
      const cached = localStorage.getItem(`${CACHE_KEY_PREFIX}${dashboardType}`);
      if (cached) {
        return JSON.parse(cached);
      }
    } catch (error) {
      console.error(`Error reading cache for ${dashboardType}:`, error);
    }
    return [];
  },

  // Set cached data for a specific dashboard
  set(dashboardType, data) {
    try {
      if (data && Array.isArray(data) && data.length > 0) {
        localStorage.setItem(`${CACHE_KEY_PREFIX}${dashboardType}`, JSON.stringify(data));
      }
    } catch (error) {
      console.error(`Error setting cache for ${dashboardType}:`, error);
    }
  },

  // Clear cache for a specific dashboard
  clear(dashboardType) {
    try {
      localStorage.removeItem(`${CACHE_KEY_PREFIX}${dashboardType}`);
    } catch (error) {
      console.error(`Error clearing cache for ${dashboardType}:`, error);
    }
  },

  // Clear all dashboard caches
  clearAll() {
    try {
      Object.keys(localStorage).forEach(key => {
        if (key.startsWith(CACHE_KEY_PREFIX)) {
          localStorage.removeItem(key);
        }
      });
    } catch (error) {
      console.error("Error clearing all dashboard caches:", error);
    }
  }
};

